import heroImg from "../../assets/HeroImg.svg";
import penIcon from "../../assets/Pen Icon.svg";
import bookIcon from "../../assets/book Icon.svg";
import Navigation from "../Shared/Navigation";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useT } from "../../i18n/I18nContext";
import Seo from "../../seo/Seo";
import Page from "../../a11y/Page";

const Landing = () => {
  const t = useT();
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <>
      <Seo
        path="/"
        description={t("landing.hero.description")}
      />
      <Navigation searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      {!searchQuery && (
        <Page className="grid grid-cols-1 md:grid-cols-2 bg-bg">
          {/* Hero left / text */}
          <div className="mx-10 md:ml-20 max-md:mb-24">
            <h1 className="mt-20 md:mt-[138px] text-[36px]/[48px] xl:text-[64px]/[83px] font-bold text-text text-center md:text-left">
              {t("landing.hero.headline_prefix")} <br />
              <span className="text-primary">
                {t("landing.hero.headline_accent")}
              </span>
            </h1>
            <p className="text-secondText md:text-[20px]/[32px] xl:text-[24px]/[40px] my-8 text-center md:text-left">
              {t("landing.hero.description")}
            </p>
            <div className="flex flex-col lg:flex-row justify-center gap-6">
              <Link
                to="/work"
                className="bg-primary py-3 px-4 md:py-4 md:px-6 lg:py-3 lg:px-4
                  rounded-lg flex items-center justify-center font-bold
                  text-white text-lg md:text-xl cursor-pointer lg:flex-1
                  hover:brightness-110 transition"
              >
                <img
                  src={penIcon}
                  alt=""
                  aria-hidden="true"
                  className="mr-3 md:mr-4"
                />
                {t("landing.cta.start_writing")}
              </Link>
              <Link
                to="/browse"
                className="bg-surface py-3 px-4 md:py-4 md:px-6 lg:py-3 lg:px-4
                  border border-border rounded-lg flex items-center justify-center
                  font-bold text-secondText text-lg md:text-xl cursor-pointer lg:flex-1
                  hover:text-primary hover:border-primary transition"
              >
                <img
                  src={bookIcon}
                  alt=""
                  aria-hidden="true"
                  className="mr-3 md:mr-4"
                />
                {t("landing.cta.reading")}
              </Link>
            </div>
          </div>

          {/* Hero right / image */}
          <div className="hidden md:block">
            <img src={heroImg} alt="" aria-hidden="true" className="w-full" />
          </div>
        </Page>
      )}
    </>
  );
};

export default Landing;
